export default {
    state: {
        learns: [
            {
                title: 'Онлайн-курсы',
                text: 'Найди свой курс, выполняй упражнения, стань ' +
                    'профессионалом в интересной области',
                // link: 'courses',
                link: 'events',
                link_params: { type: 'courses', page: 1 },
                img: 'online',
            },
            {
                title: 'Очные мероприятия',
                text: 'Приходи на встречи с лидерами, записывайся' +
                    ' на тренинги',
                // link: 'events',
                link: 'events',
                link_params: { type: 'events', page: 1 },
                img: 'offline',
            },
            {
                title: 'Вебинары',
                text: 'Подай заявку на интересующие тебя вебинары' +
                    ' и пройди лучшие курсы online',
                // link: 'webinars',
                link: 'events',
                link_params: { type: 'webinars', page: 1 },
                img: 'webinar',
            },
        ],
        tests: [
            {
                title: 'Пройти тест на профориентацию',
                text: 'Профтест, Демоверсия 1.0',
                link: null,
                testId: "9999c901-f8ad-4509-894f-c9e5f9a39fd5",
                img: 'test',
                blank: true,
            },
            {
                title: 'Найди наставника среди состоявшихся профессионалов',
                text: 'А тебе самому есть что сказать?',
                link: '/portal/mentoring',
                img: 'mentor',
                testId: null,
            },
        ],
    },
    getters: {
        pumps_learns: state => state.learns,
        pumps_tests: state => state.tests,
    },
};
